import { handleGqlResponseBody } from '@/utils/apollo.util';
import { GET_MY_NOTIFICATIONS_QUERY } from '@/graphql/queries/notifications/get-my-notifications.query';
import { GET_UNREAD_NOTIFICATIONS_COUNT_QUERY } from '@/graphql/queries/notifications/get-unread-notifications-count.query';
import { MARK_NOTIFICATION_AS_READ_MUTATION } from '@/graphql/mutations/notifications/mark-notification-as-read.mutation';
import { MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION } from '@/graphql/mutations/notifications/mark-all-notifications-as-read.mutation';

const notifications = {
  state: {
    notifications: [],
    total: 0,
    hasMore: false,
    unreadCount: 0
  },
  getters: {
    getNotifications: (state) => state.notifications,
    getUnreadCount: (state) => state.unreadCount
  },
  mutations: {
    SET_NOTIFICATIONS(state, { items, total, hasMore, extraData }) {
      state.notifications = items;
      state.total = total;
      state.hasMore = hasMore;
      if (extraData && typeof extraData.unreadCount === 'number') {
        state.unreadCount = extraData.unreadCount;
      }
    },
    SET_UNREAD_COUNT(state, count) {
      state.unreadCount = count;
    }
  },
  actions: {
    async fetchMyNotifications({ commit }, paginationInput) {
      const result = await handleGqlResponseBody(apollo => {
        return apollo.query({
          query: GET_MY_NOTIFICATIONS_QUERY,
          variables: {
            data: {
              pagination: {
                skip: paginationInput.skip,
                take: paginationInput.take
              },
              orderBy: paginationInput.orderBy,
              from: paginationInput.from,
              to: paginationInput.to
            }
          },
          fetchPolicy: 'no-cache'
        });
      });
      if (result) {
        commit('SET_NOTIFICATIONS', result);
      }
      return result;
    },
    async fetchUnreadCount({ commit }) {
      const result = await handleGqlResponseBody(apollo => {
        return apollo.query({
          query: GET_UNREAD_NOTIFICATIONS_COUNT_QUERY,
          fetchPolicy: 'no-cache'
        });
      });
      if (typeof result === 'number') {
        commit('SET_UNREAD_COUNT', result);
      }
      return result;
    },
    async markNotificationsAsRead({ dispatch }, notificationIds) {
      const result = await handleGqlResponseBody(apollo => {
        return apollo.mutation({
          mutation: MARK_NOTIFICATION_AS_READ_MUTATION,
          variables: {
            data: {
              notificationIds
            }
          }
        });
      });
      if (result) {
        await dispatch('fetchUnreadCount');
      }
      return result;
    },
    async markAllNotificationsAsRead({ dispatch }) {
      const result = await handleGqlResponseBody(apollo => {
        return apollo.mutation({
          mutation: MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION
        });
      });
      if (result) {
        await dispatch('fetchUnreadCount');
      }
      return result;
    }
  }
};

export default notifications;
